import BaseComponent from 'foundation/base-component';
import Cookies from 'js-cookie';
import { AppState } from '@aws-amplify/core';
import app from '../../../general/js/app'; 

export default class ResetPasswordUrlComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        const secutixCookie = Cookies.get('secutixConfig');
        if (secutixCookie !== undefined) {
            const secutixConfiguration = JSON.parse(secutixCookie);
			this.element.setAttribute('href', secutixConfiguration.resetPasswordUrl);
        }
        else {
            this.element.setAttribute('href', app.state.resetPasswordLink);
        }
    }
}
